import Service from "../../services"

const Med = {
  namespaced: true,

  strict: true,

  state: {
    meds: [],
    med: {},
    medSearch: {
      name_th: '',
      name_en: '',
      main_group: '',
      sub_group: '',
      spec_no: '',
      spec_code: '',
      year: '',
      row_per_page: 10
    },
    pagination: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1
    },
  },
  mutations: {
    SET_MEDS: (state, res) => {
      state.meds = res;
      state.pagination = {
        current_page: res.current_page,
        from: res.from,
        last_page: res.last_page,
        next_page_url: res.next_page_url,
        per_page: res.per_page,
        total: res.total,
        to: res.to,
      };
    },
    SET_MED: (state, med) => {
      state.med = med
    },
    SET_PAGINATION: (state, pagination) => {
      state.pagination = pagination
    },
    CLEAR_SEARCH: state => {
      state.pagination = {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    },
    CLEAR: state => {
      state.medSearch = {
        name_th: '',
        name_en: '',
        main_group: '',
        sub_group: '',
        spec_no: '',
        spec_code: '',
        year: '',
      }
    }
  },
  actions: {
    async searchMeds ({ commit, state }, dataSearch) {
      const main_group = state.medSearch.main_group ? state.medSearch.main_group.group_main : '';
      const sub_group = state.medSearch.sub_group ? state.medSearch.sub_group.sub_group1 : '';
      const data = await Service.Med.getSearch({ ...state.medSearch, main_group,sub_group, dataSearch})
      commit('SET_MEDS', data)
    },
    async getMed ({ commit }, id) {
      const data = await Service.Med.getById(id)
      commit('SET_MED', data)
      return data;
    },
    clearSearch({commit}) {
      commit("CLEAR_SEARCH");
    },
    clear({commit}) {
      commit("CLEAR");
    },

    getOrderPDF({commit}, id) {
      return Service.Med.getOrderPDF(id)
    }

  },


}
export default Med
